module.exports = {
    "MISSSING_ACCESS_TOKEN": "F001",
    "ERROR_DECODING_ACCESS_TOKEN": "F002",
    "MISSING_SHOP_PARAMETER_ON_INDEX": "F003",
    "MISSING_SHOP_PARAMETER_ON_APP": "F004",
    "ERROR_GETTING_SHOP_DATA": "F005",
    "GENERIC_ERROR": "F999"
};